// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"161":"product-details","353":"contact","385":"default-layout","594":"about","757":"not-found","962":"home","983":"products"}[chunkId] || chunkId) + "." + {"72":"3eb14389","161":"d12e9a28","353":"8aba9056","385":"797aea0a","594":"8fc408be","757":"cb884fc4","962":"fea5fe31","983":"d5b1b10b"}[chunkId] + ".js";
};